import { render, staticRenderFns } from "./FilterSocialType.vue?vue&type=template&id=4b6bb0d0&scoped=true"
import script from "./FilterSocialType.vue?vue&type=script&lang=ts"
export * from "./FilterSocialType.vue?vue&type=script&lang=ts"
import style0 from "./FilterSocialType.vue?vue&type=style&index=0&id=4b6bb0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bb0d0",
  null
  
)

export default component.exports